import {GlobalWatch} from '@acng/frontend-relativity';
import {now} from '@acng/frontend-bounty/std/date.js';
import {create, SCRIPT} from '@acng/frontend-bounty/dom/element.js';
import {head} from '@acng/frontend-bounty/dom/document.js';
import {append} from '@acng/frontend-bounty/dom/move.js';
import {make} from '../core/service/env.js';
import {Portal} from '../portal.js';
import {ctxAuthUser} from './context/auth-user.js';
import {isConnected} from '@acng/frontend-bounty/dom/type.js';

const url = make(Portal).script.matomo;

if (url) {
  const script = create(SCRIPT);
  script.async = true;
  script.src = url;

  GlobalWatch(ctxAuthUser)((user) => {
    if (isConnected(script)) {
      console.warn('already connected');
      return;
    }

    if (!user) {
      return;
    }

    const mtm = [{'mtm.startTime': now(), 'event': 'mtm.Start'}];
    window.iV = {user: {userId: user.id}};
    window._mtm = mtm;
    append(head, script);
  });
}
